// Libs
import { connect } from 'react-redux'

// Component
import GridControl from '../components/GridControls/Controls'

// Action creators
import {
  changeGridSize,
  changeGridRotation,
  changeGridOffset,
} from 'hfty-map/src/actions'

// Selectors
import operation$ from 'hfty-soil-jobs-dom/src/selectors/operation'
import { selectedFeatureIndices$ } from 'hfty-map'
import { calcGrid$ } from 'hfty-grid'

// Operators
import soilJobsOperator from 'fc-operator-sampling-jobs'

const mapDispatchToProps = {
  onChangeGridSize: changeGridSize,
  onChangeGridRotate: changeGridRotation,
  onChangeGridOffset: changeGridOffset,
  onUpdateGrid: soilJobsOperator.actionCreators.updateOperation,
}

const mapStateToProps = (state) => ({
  gridData: calcGrid$(state),
  operation: operation$(state),
  selectedFeatureIndices: selectedFeatureIndices$(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(GridControl)
